import React from 'react'
import { Link } from 'react-router-dom'
import { LInkdinURL } from '../../Config'
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Linkdin_secren from '../../assets/images/Linkdin-home.png';
import SKill from './SKill';

const AboutIn = () => {

     const popover = (
          <Popover id="popover-basic" className="bg-dark" >
               <Popover.Body>
                    <img src={Linkdin_secren} alt='linkdin-home' />
               </Popover.Body>
          </Popover>
     );

     const projects = [
          {
               current: true,
               link: "https://www.jstechservices.in/",
               number: "March 20, 2024 - Present",
               icon: "https://jstechservices.in/wp-content/uploads/2025/03/fav-150x150.jpg",
               name: "JS Tech Services",
               description: " Elevating mobile experiences, pushing boundaries, and refining my craft.",
          },
          {
               current: false,
               link: "https://www.gnisoftsolutions.com/",
               number: "July 1, 2022 - March 20, 2024",
               icon: "https://www.gnisoftsolutions.com/wp-content/uploads/2019/11/gni-fb.png",
               name: "GNI Soft Solutions LLP",
               description: "Where my journey began, shaping my core React Native expertise.",
          },
          
     ];


     return (
          <>

               <div className='__about-sec' id='aboutMe'>

                    <div className='content-center'>
                         <div className='__as-head'>
                              <h6 className='__connct'>Let's connect and build something amazing!</h6>
                              <h1>Hello, I'm
                                   <OverlayTrigger trigger="hover" placement="top" overlay={popover}>
                                        <Link to={LInkdinURL} className="link" target='_blank'> Parwinder Singh</Link>
                                   </OverlayTrigger>
                                   .</h1>
                              <h5>A passionate <Link className="link" target='_blank' to="https://reactnative.dev/"> React Native Developer</Link> with 3 years of experience in building high-performance cross-platform mobile apps.</h5>
                              <p>Passionate about crafting seamless mobile experiences, I have been immersed in the world of React Native since July 1, 2022. From building dynamic, high-performance apps to exploring the latest in cross-platform development, I thrive on transforming ideas into reality. With a keen eye for detail and a love for innovation, I’m always pushing the boundaries to create intuitive and engaging user experiences.</p>
                         </div>

                         <div className='__as-project'>
                              <div className='row'>

                              {projects.map((project, index) => (
                                        <div className='col-md-6'>
                                             <div className={`__project-card ${index === 1 ? 'project-card-2' : '' } `} key={index}>
                                                  <div className="__icon">
                                                       <img src={project.icon} alt='icon'/>
                                                  </div>

                                                  <div className="names">
                                                       <h5> Work Experience : {project.name} {project.current ? <span> </span> : ''}</h5>
                                                       <p>{project.description}</p>
                                                       <h6 className="times">{project.number}</h6>
                                                       <Link to={project.link} target='_blank' className="stretched-link"></Link>
                                                  </div>
                                             </div>
                                        </div>
                                   ))}

                                   

                                   <div className='col-12'>
                                        <div className='__divider'>
                                             <div className='__divider-in'></div>
                                        </div>
                                   </div>

                                   <div className='col-12'>
                                        <SKill/>
                                   </div>
                                   
                              </div>
                         </div>
                    </div>
               </div>
          </>
     )
}

export default AboutIn
